<template>
  <modal-template
    ref="modal"
    :title="'Alterações não salvas'"
    type-modal="unsaved_changes_modal"
  >
    <div class="modal-content__main">
      <p>
        Há alterações não salvas. Deseja continuar sem salvar?
      </p>
    </div>
    <div slot="actions" class="modal-content__control">
      <d-button type="button" @click="close" class="btn btn-sm btn-secondary mr-2">
        Cancelar
      </d-button>
      <d-button
        type="button"
        @click.stop="confirm"
        class="btn btn-sm btn-success"
      >
        Continuar
      </d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import ModalTemplate from '_shared/Modal.vue';

export default {
  name: 'unsaved-changes-modal',
  components: {
    ModalTemplate,
  },
  methods: {
    ...mapActions(['setToggle']),
    confirm() {
      this.$emit('confirm', this.templateName);
    },
    close() {
      this.setToggle({ type: 'unsaved_changes_modal', bool: false });
    },
  },
};
</script>
